<template>
  <div>
    <cx-check-box :value.sync="showangleAxis">显示纵轴</cx-check-box>
    <div v-if="showangleAxis && checkType(showangleAxis)">
      <div>
        <p class="font14 mb16 mt16">纵轴文字</p>
        <!-- 字体和颜色/字重和字号 -->
        <text-setting-update
          colorMode="chart"
          :fontColor.sync="angleAxisFontColor"
          :fontFamily.sync="angleAxisFontFamily"
          :fontSize.sync="angleAxisFontSize"
          :fontWeight.sync="angleAxisFontWeight"
        />
      </div>
      <slider-and-input
        class="mt16"
        v-if="checkType(angleAxisLabelPaddingBottom)"
        :value.sync="angleAxisLabelPaddingBottom"
        title="下边距"
        :sliderMin="-50"
        :sliderMax="50"
        suffix="px"
      />
      <slider-and-input
        class="mt16"
        v-if="checkType(angleAxisLabelPaddingRight)"
        :value.sync="angleAxisLabelPaddingRight"
        title="右边距"
        :sliderMin="-30"
        :sliderMax="200"
        suffix="px"
      />
      <cx-check-box class="mt16" :value.sync="showAngleAxisTextBackground">{{ axisLabelText }}</cx-check-box>
      <!--文本背景色/圆角/边距设置-->
      <div v-if="showAngleAxisTextBackground">
        <double-input
          class="mt16"
          title="尺寸"
          placeHolderText="必填"
          :value1.sync="angleAxisLabelPaddingWidth"
          :value2.sync="angleAxisLabelPaddingHeight"
          inputSuffixs="px"
        />
        <!--轴线文本边框圆角-->
        <slider-and-input
          class="mt16"
          v-if="checkType(angleAxisLabelBorderRadius)"
          :value.sync="angleAxisLabelBorderRadius"
          title="圆角"
          :sliderMax="15"
          suffix="px"
        />
        <!--轴线文本边框右边距-->
        <slider-and-input
          class="mt16"
          v-if="checkType(angleAxisLabelMargin)"
          :value.sync="angleAxisLabelMargin"
          title="右边距"
          :sliderMax="100"
          :sliderMin="-100"
          suffix="px"
        />
        <!-- 默认文字背景色 -->
        <div v-if="typeof AngleAxisTextBackground === 'string'">
          <color-picker
            class="mt16"
            :color.sync="AngleAxisTextBackground"
            titlePosition="singleLine"
            title="默认背景色"
          />
        </div>
        <div v-else>
          <label class="font14 inlineMiddle mr24 mt16">默认背景色</label>
          <color-picker
            class="mt16"
            :color="AngleAxisTextBackground.colorStops[1].color"
            @change="changePrimaryBackgroundColor(1, $event)"
            titlePosition="allInOneLine"
            title="开始颜色"
          />
          <color-picker
            class="mt16"
            :color="AngleAxisTextBackground.colorStops[0].color"
            @change="changePrimaryBackgroundColor(0, $event)"
            titlePosition="allInOneLine"
            title="结束颜色"
          />
        </div>
        <!-- 特殊背景色 -->
        <div class="mt16" v-if="angleAxisData.length">
          <label class="font14 inlineMiddle mr24"
            >特殊背景色<span @click="addBackgroundControl" class="icon-portal-plus-small right_font"
          /></label>

          <div
            class="single_bg"
            v-for="(rich, key) in singleBackground"
            :key="rich.name"
            @dragover.prevent
            @drop="stopChangePosition(rich, $event)"
          >
            <div class="single_color_icons">
              <div class="icon_set">
                <img :src="Vector" draggable="true" @dragstart="startChangePosition(rich, $event)" />
              </div>
              <div class="icon_set">
                <span @click="delRchSingleColor(rich, key)" class="icon-portal-delete" />
              </div>
            </div>
            <div>
              <el-radio-group :value="getRichBgType(rich)" @change="changeRankBgType(rich, $event)">
                <el-radio label="纯色">纯色</el-radio>
                <el-radio label="线性渐变">线性渐变</el-radio>
              </el-radio-group>
            </div>
            <div v-if="typeof rich.backgroundColor === 'string'">
              <color-picker @change="changeRichColor(rich, undefined, $event)" :color="rich.backgroundColor" />
            </div>
            <div v-else>
              <color-picker
                class="mt12"
                :color="rich.backgroundColor.colorStops[1].color"
                @change="changeRichColor(rich, 1, $event)"
                title="开始颜色"
                titlePosition="allInOneLine"
              />
              <color-picker
                class="mt8"
                :color="rich.backgroundColor.colorStops[0].color"
                @change="changeRichColor(rich, 0, $event)"
                titlePosition="allInOneLine"
                title="结束颜色"
              />
            </div>
          </div>
          <!-- <span></span><span></span> -->
          <!-- </div> -->
        </div>
      </div>
      <div class="mt16" v-if="this.axisLabelType">
        <label class="font14 inlineMiddle mr24">柱上文字设置</label>
        <text-setting-update
          class="mt8"
          colorMode="chart"
          :fontColor.sync="angleAxisLabelTextOnBarFontColor"
          :fontFamily.sync="angleAxisLabelTextOnBarFonFamily"
          :fontSize.sync="angleAxisLabelTextOnBarFontSize"
          :fontWeight.sync="angleAxisLabelTextOnBarFontWeight"
        />
        <slider-and-input
          v-if="checkType(angleAxisLabelPaddingBottomTextOnBar)"
          class="mt8"
          :value.sync="angleAxisLabelPaddingBottomTextOnBar"
          title="下边距"
          :sliderMax="100"
          :sliderMin="-100"
          suffix="px"
        />
        <slider-and-input
          v-if="checkType(angleAxisLabelPaddingLeftTextOnBar)"
          class="mt8"
          :value.sync="angleAxisLabelPaddingLeftTextOnBar"
          title="左边距"
          :sliderMax="100"
          suffix="px"
        />
        <el-checkbox v-model="angleAxisDataValueMaxLengthControl">文字长度限制</el-checkbox>
        <slider-and-input
          v-if="angleAxisDataValueMaxLengthControl && checkType(angleAxisDataValueMaxLength)"
          class="mt8"
          :value.sync="angleAxisDataValueMaxLength"
          title="文字长度"
          :sliderMax="100"
          suffix="个"
        />
      </div>
      <!--单位设置-->
      <div class="mt16" v-if="checkType(showAngleAxisUnit)">
        <cx-check-box :value.sync="showAngleAxisUnit">显示单位</cx-check-box>
        <div class="mt16" v-if="showAngleAxisUnit">
          <span class="font14 mr10 half-label">单位文本</span>
          <el-input
            class="width-half-bigWidth el-input el-input--suffix"
            placeholder="请输入"
            v-model="showAngleAxisUnitValue"
          >
          </el-input>
        </div>
        <!-- 单位文字设置 -->
        <div class="mt16" v-if="showAngleAxisUnit">
          <text-setting-update
            colorMode="chart"
            :fontColor.sync="angleAxisUnitValueFontColor"
            :fontFamily.sync="angleAxisUnitValueFontFamily"
            :fontSize.sync="angleAxisUnitValueFontSize"
            :fontWeight.sync="angleAxisUnitValueFontWeight"
          />
          <slider-and-input
            class="mt16"
            :value.sync="angleAxisUnitValuepaddingBottom"
            title="单位上边距"
            :sliderMax="50"
            :sliderMin="-50"
            suffix="px"
          />
          <slider-and-input
            class="mt16"
            :value.sync="angleAxisUnitValuepaddingLeft"
            title="单位左边距"
            :sliderMax="50"
            :sliderMin="-50"
            suffix="px"
          />
        </div>
      </div>
      <div class="mt16" v-if="options.type === 'Line'">
        <double-input
          class="mt16"
          title="纵轴范围"
          placeHolderText="自动"
          :value1.sync="min"
          :value2.sync="max"
          inputSuffixs="px"
        />
      </div>
      <div
        class="mt16"
        v-if="checkType(angleAxisLineType) || checkType(angleAxisLineWidth) || checkType(angleAxisLabelColor)"
      >
        <!-- <div class="mt16"> -->
        <!--轴线类型-->
        <div class="mt16 verticallyCenterAround">
          <line-setting
            title="轴线样式"
            :lineName.sync="angleAxisLineType"
            :lineWidth.sync="angleAxisLineWidth"
            :lineColor.sync="angleAxisLabelColor"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import publicData from "./publicData"
import Vector from "assets/images/Vector.png"
export default {
  mixins: [publicData],
  props: {
    options: {
      type: Object
    },
    ids: {
      type: Object
    }
  },
  data() {
    return {
      Vector,
      this1: this,
      barSettingType: "single",
      singleBackground: []
    }
  },
  computed: {
    axisLabelType() {
      //ture代表当前柱状图是排序的且有描述文字的纵轴，false表示是普通的
      return !!this.hasProperty(this.chartOpt, "angleAxis.axisLabel.rich.rank")
    },
    axisLabelText() {
      return this.axisLabelType ? "显示纵轴排序文字背景" : "显示纵轴文字背景"
    },
    chartOpt() {
      return this.options.chartOption
    },

    angleAxisData() {
      return this.hasProperty(this.chartOpt, "angleAxis.data")
    },
    showAngleAxisUnitValue: {
      get() {
        return this.chartOpt.angleAxis.name
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.angleAxis.name", false)
      }
    },
    showAngleAxisUnit: {
      get() {
        return !!this.chartOpt.angleAxis.name.length
      },
      set(newVal) {
        if (newVal) {
          this.$changeOptionsEV(" ", "chartOption.angleAxis.name", false)
        } else {
          this.$changeOptionsEV("", "chartOption.angleAxis.name", false)
        }
      }
    },
    angleAxisUnitValueFontFamily: {
      get() {
        return this.checkAndSetPrimaryVal(this.chartOpt, "angleAxis.nameTextStyle.fontFamily", "angleAxisUnitValueFontFamily", "sans-serif")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.angleAxis.nameTextStyle.fontFamily", false)
      }
    },
    angleAxisUnitValueFontSize: {
      get() {
        return this.chartOpt.angleAxis.nameTextStyle.fontSize
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.angleAxis.nameTextStyle.fontSize", false)
      }
    },
    angleAxisUnitValueFontWeight: {
      get() {
        return this.chartOpt.angleAxis.nameTextStyle.fontWeight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.angleAxis.nameTextStyle.fontWeight", false)
      }
    },
    angleAxisUnitValueFontColor: {
      get() {
        return this.chartOpt.angleAxis.nameTextStyle.color
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.angleAxis.nameTextStyle.color", false)
      }
    },
    angleAxisUnitValuepaddingBottom: {
      get() {
        return -this.hasProperty(this.chartOpt, "angleAxis.nameTextStyle.padding.2")
      },
      set(newVal) {
        this.$changeOptionsEV(-newVal, "chartOption.angleAxis.nameTextStyle.padding.2", false)
      }
    },
    angleAxisUnitValuepaddingLeft: {
      get() {
        return this.hasProperty(this.chartOpt, "angleAxis.nameTextStyle.padding.3")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.angleAxis.nameTextStyle.padding.3", false)
      }
    },
    min: {
      get() {
        return this.hasProperty(this.chartOpt, "angleAxis.min")
      },
      set(newVal) {
        if (typeof newVal !== undefined && newVal.length >= 1) {
          this.$changeOptionsEV(newVal, "chartOption.angleAxis.min", false)
        }
      }
    },
    max: {
      get() {
        return this.hasProperty(this.chartOpt, "angleAxis.max")
      },
      set(newVal) {
        if (typeof newVal !== undefined && newVal.length >= 1) {
          this.$changeOptionsEV(newVal, "chartOption.angleAxis.max", false)
        }
      }
    },
    angleAxisLabelPaddingBottom: {
      get() {
        return this.hasProperty(this.chartOpt, `angleAxis.data.0.textStyle.padding.2`)
      },
      set(newVal) {
        if (newVal !== this.angleAxisLabelPaddingBottom) {
          this.chartOpt.angleAxis.data.forEach((itemData, index) => {
            this.$changeOptionsEV(newVal, `chartOption.angleAxis.data.${index}.textStyle.padding.2`, false)
          })
        }
      }
    },
    angleAxisLabelPaddingRight: {
      get() {
        return this.hasProperty(this.chartOpt, `angleAxis.data.0.textStyle.padding.1`)
      },
      set(newVal) {
        if (newVal !== this.angleAxisLabelPaddingRight) {
          this.chartOpt.angleAxis.data.forEach((itemData, index) => {
            this.$changeOptionsEV(newVal, `chartOption.angleAxis.data.${index}.textStyle.padding.1`, false)
          })
        }
      }
    },
    showangleAxis: {
      get() {
        return this.hasProperty(this.chartOpt, "angleAxis.show")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.angleAxis.show", false)
      }
    },
    //轴线文字设置
    angleAxisFontFamily: {
      get() {
        return this.quickGetRankProperty("fontFamily")
      },
      set(newVal) {
        this.forEachSetRankProperty(newVal, "fontFamily")
      }
    },
    angleAxisFontColor: {
      get() {
        return this.quickGetRankProperty("color")
      },
      set(newVal) {
        this.forEachSetRankProperty(newVal, "color")
      }
    },
    angleAxisFontWeight: {
      get() {
        return this.quickGetRankProperty("fontWeight")
      },
      set(newVal) {
        this.forEachSetRankProperty(newVal, "fontWeight")
      }
    },
    angleAxisFontSize: {
      get() {
        return this.quickGetRankProperty("fontSize")
      },
      set(newVal) {
        this.forEachSetRankProperty(newVal, "fontSize")
      }
    },
    //轴线文字设置结束
    angleAxisLabelColor: {
      get() {
        return this.hasProperty(this.chartOpt, "angleAxis.axisLine.lineStyle.color")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.angleAxis.axisLine.lineStyle.color", false)
      }
    },
    angleAxisLineType: {
      get() {
        return this.hasProperty(this.chartOpt, "angleAxis.axisLine.lineStyle.type")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.angleAxis.axisLine.lineStyle.type", false)
      }
    },
    angleAxisLineWidth: {
      get() {
        return this.hasProperty(this.chartOpt, "angleAxis.axisLine.lineStyle.width")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.angleAxis.axisLine.lineStyle.width", false)
        this.$changeOptionsEV(newVal, "chartOption.angleAxis.axisLine.lineStyle.width", false)
      }
    },
    showAngleAxisTextBackground: {
      get() {
        if (this.axisLabelType) {
          //排序柱状图的情况
          return (
            this.hasProperty(this.chartOpt, "angleAxis.axisLabel.rich.rank0.backgroundColor") !== "rgba(255, 255, 0, 0)"
          )
        } else {
          //普通柱状图的情况
          return this.hasProperty(this.chartOpt, "angleAxis.axisLabel.backgroundColor") !== "rgba(255, 255, 0, 0)"
        }
      },
      set(newVal) {
        if (this.axisLabelType) {
          if (newVal) {
            this.forEachSetRankProperty("rgba(252, 73, 28, 1)", "backgroundColor")

            // )
          } else {
            this.forEachSetRankProperty("rgba(255, 255, 0, 0)", "backgroundColor")
          }
        } else {
          if (newVal) {
            this.$changeOptionsEV("rgba(252, 73, 28, 1)", "chartOption.angleAxis.axisLabel.backgroundColor", false)
          } else {
            this.$changeOptionsEV("rgba(255, 255, 0, 0)", "chartOption.angleAxis.axisLabel.backgroundColor", false)
          }
        }
      }
    },
    AngleAxisTextBackground: {
      get() {
        if (this.axisLabelType) {
          //排序柱状图的情况
          return this.hasProperty(this.chartOpt, "angleAxis.axisLabel.rich.rank.backgroundColor")
        } else {
          //普通柱状图的情况
          return this.hasProperty(this.chartOpt, "angleAxis.axisLabel.backgroundColor")
        }
      },
      set(newVal) {
        if (this.axisLabelType) {
          let ranks = this.chartOpt.angleAxis.axisLabel.rich
          this.$changeOptionsEV(newVal, `chartOption.angleAxis.axisLabel.rich.rank.backgroundColor`, false)
          Object.keys(ranks).forEach(k => {
            if (k.includes("rank") && k.length > "rank".length && !ranks[k].singleColor) {
              this.$changeOptionsEV(newVal, `chartOption.angleAxis.axisLabel.rich.${k}.backgroundColor`, false)
            }
          })
        } else {
          this.$changeOptionsEV(newVal, "chartOption.angleAxis.axisLabel.backgroundColor", false)
        }
      }
    },
    angleAxisLabelPaddingBottomTextOnBar: {
      get() {
        return Number(this.hasProperty(this.chartOpt, "angleAxis.axisLabel.rich.title.padding.2"))
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.angleAxis.axisLabel.rich.title.padding.2", false)
      }
    },
    angleAxisLabelPaddingLeftTextOnBar: {
      get() {
        return Number(this.hasProperty(this.chartOpt, "angleAxis.axisLabel.rich.title.padding.3"))
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.angleAxis.axisLabel.rich.title.padding.3", false)
      }
    },
    angleAxisDataValueMaxLengthControl: {
      //柱上文字长度限制
      get() {
        return this.hasProperty(this.chartOpt, "angleAxis.dataValueLengthControl")
      },
      set(newVal) {
        // if (newVal) {
        //   this.subAxisDataValueLength(this.hasProperty(this.chartOpt, "angleAxis.dataValueLength"))
        // } else {
        //   this.addAxisDataValueLength()
        // }
        this.$changeOptionsEV(newVal, `chartOption.angleAxis.dataValueLengthControl`, false)
      }
    },
    angleAxisDataValueMaxLength: {
      //柱上文字长度限制
      get() {
        return this.hasProperty(this.chartOpt, "angleAxis.dataValueLength")
      },
      set(newVal) {
        const oldVal = this.hasProperty(this.chartOpt, "angleAxis.dataValueLength")
        if (newVal === oldVal) return
        this.$changeOptionsEV(newVal, `chartOption.angleAxis.dataValueLength`, false)
        // if (newVal < oldVal) {
        //   this.subAxisDataValueLength(newVal)
        // } else {
        //   this.addAxisDataValueLength(newVal)
        // }
      }
    },
    //柱上文字设置
    angleAxisLabelTextOnBarFontColor: {
      get() {
        return this.hasProperty(this.chartOpt, "angleAxis.axisLabel.rich.title.color")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, `chartOption.angleAxis.axisLabel.rich.title.color`, false)
      }
    },
    angleAxisLabelTextOnBarFontSize: {
      get() {
        return Number(this.hasProperty(this.chartOpt, "angleAxis.axisLabel.rich.title.fontSize"))
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, `chartOption.angleAxis.axisLabel.rich.title.fontSize`, false)
      }
    },
    angleAxisLabelTextOnBarFonFamily: {
      get() {
        return this.hasProperty(this.chartOpt, "angleAxis.axisLabel.rich.title.fontFamily")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, `chartOption.angleAxis.axisLabel.rich.title.fontFamily`, false)
      }
    },
    angleAxisLabelTextOnBarFontWeight: {
      get() {
        return this.hasProperty(this.chartOpt, "angleAxis.axisLabel.rich.title.fontWeight")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, `chartOption.angleAxis.axisLabel.rich.title.fontWeight`, false)
      }
    },

    //柱上文字设置结束
    angleAxisLabelPaddingWidth: {
      get() {
        if (this.axisLabelType) {
          return Number(this.hasProperty(this.chartOpt, "angleAxis.axisLabel.rich.rank0.width"))
        } else {
          return Number(this.hasProperty(this.chartOpt, "angleAxis.axisLabel.padding.0"))
        }
      },
      set(newVal) {
        if (this.axisLabelType) {
          let ranks = this.chartOpt.angleAxis.axisLabel.rich
          Object.keys(ranks).forEach(k => {
            if (k.includes("rank") && k.length > "rank".length) {
              this.$changeOptionsEV(newVal, `chartOption.angleAxis.axisLabel.rich.${k}.width`, false)
            }
          })
        } else {
          this.$changeOptionsEV(newVal, "chartOption.angleAxis.axisLabel.padding.0", false)
        }
      }
    },
    angleAxisLabelPaddingHeight: {
      get() {
        if (this.axisLabelType) {
          return Number(this.hasProperty(this.chartOpt, "angleAxis.axisLabel.rich.rank0.height"))
        } else {
          return Number(this.hasProperty(this.chartOpt, "angleAxis.axisLabel.padding.1"))
        }
      },
      set(newVal) {
        if (this.axisLabelType) {
          let ranks = this.chartOpt.angleAxis.axisLabel.rich
          Object.keys(ranks).forEach(k => {
            if (k.includes("rank") && k.length > "rank".length) {
              this.$changeOptionsEV(newVal, `chartOption.angleAxis.axisLabel.rich.${k}.height`, false)
            }
          })
        } else {
          this.$changeOptionsEV(newVal, "chartOption.angleAxis.axisLabel.padding.1", false)
        }
      }
    },
    angleAxisLabelPadding: {
      get() {
        return this.hasProperty(this.chartOpt, "angleAxis.axisLabel.padding")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.angleAxis.axisLabel.padding.0", false)
        this.$changeOptionsEV(newVal, "chartOption.angleAxis.axisLabel.padding.1", false)
      }
    },
    angleAxisLabelBorderRadius: {
      get() {
        return Number(this.quickGetRankProperty("borderRadius"))
      },
      set(newVal) {
        this.forEachSetRankProperty(newVal, "borderRadius")
      }
    },
    angleAxisLabelMargin: {
      get() {
        return this.hasProperty(this.chartOpt, "angleAxis.axisLabel.margin")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.angleAxis.axisLabel.margin", false)
      }
    },
    angleAxisLabelRotate: {
      get() {
        return this.hasProperty(this.chartOpt, "angleAxis.axisLabel.rotate")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.angleAxis.axisLabel.rotate", false)
      }
    }
  },
  mounted() {
    this.getSingleBackground()
  },
  methods: {
    // subAxisDataValueLength(dataValueLength) {
    //   const yData = this.hasProperty(this.chartOpt, "angleAxis.data")
    //   yData.forEach((item, index) => {
    //     if (item.value.length > dataValueLength) {
    //       const newValue = item.value.slice(0, dataValueLength) //新的字符串
    //       const dropValue = item.value.slice(dataValueLength) //剩下的字符串
    //       this.$changeOptionsEV(newValue, `chartOption.angleAxis.data.${index}.value`, false)
    //       this.$changeOptionsEV(dropValue, `chartOption.angleAxis.data.${index}.dropValue`, false)
    //     }
    //   })
    // },
    // addAxisDataValueLength(dataValueLength) {
    //   const yData = this.hasProperty(this.chartOpt, "angleAxis.data")
    //   yData.forEach((item, index) => {
    //     //如果当前数据有被删除的字符串,且不为空字符串
    //     if (item.dropValue && item.dropValue.length) {
    //       //如果没有规定需要还原的字符串的长度
    //       if (isNaN(dataValueLength)) {
    //         addAllDropStr(index)
    //       } else {
    //         //如果规定了需要还原的字符串的长度
    //         const newValue = this.hasProperty(this.chartOpt, `angleAxis.data.${index}.value`)
    //         const dropValue = this.hasProperty(this.chartOpt, `angleAxis.data.${index}.dropValue`)
    //         const dropValueCheck =
    //           dropValue.length + newValue.length <= dataValueLength
    //             ? ""
    //             : dropValue.slice(0, dataValueLength - newValue.length)
    //         //如果扔下的字符串的长度加上本来的字符串长度，加起来都没有设置的字符串长度厂，那么久直接把dropvalue全部加到原本字符串（newvalue）上
    //         if (dropValueCheck.length) {
    //           const newValueWidthNewDropValue = newValue + dropValueCheck //整合当前字符串 和 从扔下字符串 中 取出来的字符串 的字符串
    //           const newDropValue = dropValue.slice(dataValueLength - newValue.length - dropValueCheck.length - 1)
    //           this.$changeOptionsEV(newValueWidthNewDropValue, `chartOption.angleAxis.data.${index}.value`, false)
    //           this.$changeOptionsEV(newDropValue, `chartOption.angleAxis.data.${index}.value`, false)
    //         } else {
    //           this.addAllDropStr(index)
    //         }
    //       }
    //     }
    //   })
    // },
    getRichBgType(rich) {
      if (typeof rich.backgroundColor === "object") {
        return "线性渐变"
      } else {
        return "纯色"
      }
    },
    addAllDropStr(index) {
      const newValue = this.hasProperty(this.chartOpt, `angleAxis.data.${index}.value`)
      const dropValue = this.hasProperty(this.chartOpt, `angleAxis.data.${index}.dropValue`)
      this.$changeOptionsEV(newValue + dropValue, `chartOption.angleAxis.data.${index}.value`, false)
      this.$changeOptionsEV("", `chartOption.angleAxis.data.${index}.dropValue`, false)
    },
    quickGetDataProperty(name) {
      return this.hasProperty(this.chartOpt, `angleAxis.data.0.textStyle.padding.2`)
    },
    quickGetRankProperty(name) {
      if (this.axisLabelType) {
        return this.hasProperty(this.chartOpt, `angleAxis.axisLabel.rich.rank0.${name}`)
      } else {
        return this.hasProperty(this.chartOpt, `angleAxis.axisLabel.${name}`)
      }
    },
    forEachSetRankProperty(newVal, name) {
      if (this.axisLabelType) {
        let ranks = this.chartOpt.angleAxis.axisLabel.rich
        Object.keys(ranks).forEach(k => {
          if (k.includes("rank") && k.length > "rank".length) {
            this.$changeOptionsEV(newVal, `chartOption.angleAxis.axisLabel.rich.${k}.${name}`, false)
          }
        })
      } else {
        this.$changeOptionsEV(newVal, `chartOption.angleAxis.axisLabel.${name}`, false)
      }
    },
    stopChangePosition(rich, e) {
      const { backgroundColor, name } = JSON.parse(e.dataTransfer.getData("dragRank"))
      const myBackgroundColor = rich.backgroundColor
      const myRankId = rich.name
      this.$changeOptionsEV(backgroundColor, `chartOption.angleAxis.axisLabel.rich.${myRankId}.backgroundColor`, false)
      this.$changeOptionsEV(myBackgroundColor, `chartOption.angleAxis.axisLabel.rich.${name}.backgroundColor`, false)
      this.getSingleBackground()
    },
    startChangePosition(rich, e) {
      e.dataTransfer.setData("dragRank", JSON.stringify(rich))
    },
    changeRankBgType(rich, newType) {
      const oldType = this.getRichBgType(rich)
      const rankId = rich.name
      if (oldType === "纯色") {
        const lineBg = {
          type: "linear",
          x: 0.5, //左
          y: 0.8, //上
          x2: 0, //右
          y2: 0, //下
          colorStops: [
            {
              offset: 0,
              color: "rgba(244, 6, 6, 1)" // 0% 处的颜色
            },
            {
              offset: 1,
              color: "rgba(7, 4, 170, 1)" // 100% 处的颜色
            }
          ],
          global: false // 缺省为 false
        }
        this.$changeOptionsEV(lineBg, `chartOption.angleAxis.axisLabel.rich.${rankId}.backgroundColor`, false)
      } else if (newType === "线性渐变") {
        this.$changeOptionsEV(
          rich.backgroundColor.colorStops[0].color,
          `chartOption.angleAxis.axisLabel.rich.${rankId}.backgroundColor`,
          false
        )
      }
      this.getSingleBackground()
    },
    delRchSingleColor(rich, singleBackgroundId) {
      const rankId = rich.name
      const defaultBackgroundColor = this.hasProperty(this.chartOpt, "angleAxis.axisLabel.rich.rank.backgroundColor")
      this.$changeOptionsEV(
        defaultBackgroundColor,
        `chartOption.angleAxis.axisLabel.rich.${rankId}.backgroundColor`,
        false
      )
      this.$changeOptionsEV(false, `chartOption.angleAxis.axisLabel.rich.${rankId}.singleColor`, false)
      this.singleBackground.splice(singleBackgroundId, 1)
    },
    changePrimaryBackgroundColor(colorIndex, color) {
      console.log(color)
      let ranks = this.chartOpt.angleAxis.axisLabel.rich
      this.$changeOptionsEV(
        color,
        `chartOption.angleAxis.axisLabel.rich.rank.backgroundColor.colorStops.${colorIndex}.color`,
        false
      )
      Object.keys(ranks).forEach(k => {
        if (k.includes("rank") && k.length > "rank".length) {
          this.$changeOptionsEV(
            color,
            `chartOption.angleAxis.axisLabel.rich.${k}.backgroundColor.colorStops.${colorIndex}.color`,
            false
          )
        }
      })
    },
    changeRichColor(rich, index, newColor) {
      const rankId = rich.name
      if (typeof index !== "undefined") {
        this.$changeOptionsEV(
          newColor,
          `chartOption.angleAxis.axisLabel.rich.${rankId}.backgroundColor.colorStops.${index}.color`,
          false
        )
      } else {
        this.$changeOptionsEV(newColor, `chartOption.angleAxis.axisLabel.rich.${rankId}.backgroundColor`, false)
      }
    },
    addBackgroundControl() {
      if (this.axisLabelType) {
        const rich = this.chartOpt.angleAxis.axisLabel.rich
        for (let k in rich) {
          if (k.includes("rank") && k.length > "rank".length && !rich[k].singleColor) {
            this.singleBackground.push({ name: k, backgroundColor: rich[k].backgroundColor })
            this.$changeOptionsEV(true, `chartOption.angleAxis.axisLabel.rich.${k}.singleColor`, false)
            break
          }
        }
      } else {
      }
    },
    getSingleBackground() {
      this.singleBackground = []
      const rich = this.chartOpt.angleAxis.axisLabel.rich
      for (let k in rich) {
        if (k.includes("rank") && k.length > "rank".length && rich[k].singleColor) {
          this.singleBackground.push({ name: k, backgroundColor: rich[k].backgroundColor })
        }
      }
    },
    changeDataBGC(index, color) {
      this.$changeOptionsEV(color, `chartOption.angleAxis.data.${index}.textStyle.backgroundColor`, false)
    },
    changeColorType(flag) {
      this.barSettingType = flag
    },
    checkFormatterValue() {
      if (!this.chartOpt.angleAxis.axisLabel.formatter) {
        this.$changeOptionsEV("{value}{valueUnit| }", "chartOption.angleAxis.axisLabel.formatter", false)
        this.$changeOptionsEV(
          {
            valueUnit: {
              fontFamily: "sans-serif",
              color: "rgba(255,255,255,1)",
              fontWeight: "400",
              fontSize: 14
            }
          },
          "chartOption.angleAxis.axisLabel.rich",
          false
        )
      }
    }
  }
}
</script>

<style scoped>
.to_input {
  display: flex;
  justify-content: space-around;
}
::v-deep.w78.color-picker-container {
  padding: 0;
  height: 32px;
}
::v-deep.w78.color-picker-container .el-color-picker {
  height: 100%;
}
::v-deep.w78 .el-color-picker__trigger {
  width: 100% !important;
  height: 100% !important;
  border-radius: 4px;
  overflow: hidden;
}
::v-deep.w78 .el-color-picker__trigger .el-color-picker__color {
  width: 100%;
  height: 100%;
}
.verticallyCenterAround {
  align-items: normal;
}
::v-deep .el-select {
  margin-bottom: 0px;
}
.bar-options-setting-dialog .tabs-color {
  width: 200px;
  height: 24px;
}
.bar-options-setting-dialog .tabs-color .tabs-color-item {
  padding: 5px 8px;
  background: #35383f;
  border-radius: 3px;
  position: static;
  width: 42px;
  height: 22px;
  font-size: 13px;
  line-height: 18px;
  color: #717989;
  cursor: pointer;
}
.bar-options-setting-dialog .tabs-color .tabs-color-item.active {
  background: var(--themeColor);
  color: #ffffff;
}
.ln40 {
  line-height: 40px;
}
.flexBox {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.el-color-picker {
  height: auto;
}
.right_font {
  position: absolute;
  right: 29.5px;
  text-align: right;
  color: var(--themeColor);
}
.right_font:hover {
  cursor: pointer;
}
.single_bg {
  /* display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between; */
  border: 1px solid #313336;
  border-radius: 4px;
  margin-top: 16px;
  padding: 12px;
}
.single_color_icons_bgType {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
}
.single_color_icons {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  position: relative;
  width: 100%;
}
.icon_set {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  position: absolute;
  width: 24px;
  height: 24px;
  top: -12px;
  background: #363a40;
}
.icon_set:first-child {
  right: 12px;
  border-radius: 0px 0px 0px 4px;
}
.icon_set:last-child {
  right: -12px;
  border-radius: 0px 4px 0px 0px;
}
.icon_set img {
  display: inline-block;
  width: 14px;
  height: 14px;
}
.icon_set img:hover {
  cursor: pointer;
}
.icon_set span:hover {
  cursor: pointer;
}
.icon_set span {
  display: inline-block;
  color: rgb(117, 120, 124);
  font-size: 14px;
}
</style>
